// extracted by mini-css-extract-plugin
module.exports = {"scopeIcon":"ScopeCell_scopeIcon__23gb0"};